module.exports = __webpack_public_path__ + "static/img/yeti.bafa23c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/not_found/yeti.png
// module id = htAE
// module chunks = 1